import * as React from "react";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

const Confirm = ({ open, setOpen, title, desc, confirmDelete, id }) => {
  //const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    //setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Dialog
      open={open}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      fullWidth
      maxWidth={"xs"}
    >
      <DialogTitle>
        <b>{title}</b>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          {desc}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="outlined" color="error">
          ยกเลิก
        </Button>
        <Button onClick={() => confirmDelete(id)} variant="contained">
          ลบ
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Confirm;
